export enum Currency {
    GBP,
    EUR,
    USD
}
